import { useI18n } from 'vue-i18n'
import type { MessageSchema, NumberSchema } from '../i18n'

type DeepKey<T> = T extends object ? { [K in keyof T]: K extends string | number ? `${K}` | `${K}.${DeepKey<T[K]>}` : never }[keyof T] : never
type ParamType = string | number | boolean | { [key: string]: string | number | boolean }
export type i18nkey = DeepKey<MessageSchema>
export function useTypedI18n () {
  const { t, n } = useI18n<{ message: MessageSchema, number: NumberSchema }>()
  return {
    t: t as <T extends i18nkey>(key: T, params?: ParamType | ParamType[]) => string,
    n: n as (value: number | string, style?: keyof NumberSchema) => string
  }
}
